/* Charm Builder — full interactive experience */
(function () {
  'use strict';

  // ─── UTILITIES ──────────────────────────────────────────────────────────────

  function formatMoney(cents, format) {
    if (!format) format = '${{amount}}';
    var val = (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return format
      .replace(/\{\{\s*amount\s*\}\}/, val)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  function parseJSON(str) {
    if (!str) return null;
    try { return JSON.parse(str.replace(/&quot;/g, '"')); } catch (_) { return null; }
  }

  function uid() { return Math.random().toString(36).slice(2, 10); }

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // Is variant "Default Title" (single, no real choice)?
  function isDefaultVariant(variants) {
    return variants.length === 1 &&
      (variants[0].title === 'Default Title' || variants[0].title === 'default title');
  }

  // ─── DEFAULT HOTSPOT POSITIONS ──────────────────────────────────────────────
  // Positions trace the outer chain ring of a square bracelet product photo.
  // The chain oval spans roughly x: 13–80%, y: 12–82%, clasp at top-right (~65%, 14%).
  // Spots go clockwise starting just left of the clasp.
  // 12 spots evenly arc-length-interpolated: spot 1 = top-right (near clasp), spot 12 = upper-left.
  var DEFAULT_HOTSPOT_POSITIONS = [
    { x: 83, y: 23 }, //  1 – top, left of clasp
    { x: 89, y: 37 }, //  2 – upper right
    { x: 91, y: 52 }, //  3 – right
    { x: 86, y: 67 }, //  4 – lower right
    { x: 76, y: 79 }, //  5 – bottom right
    { x: 63, y: 88 }, //  6 – bottom right-center
    { x: 48, y: 89 }, //  7 – bottom left-center
    { x: 33, y: 86 }, //  8 – bottom left
    { x: 20, y: 76 }, //  9 – lower left
    { x: 11, y: 63 }, // 10 – left
    { x: 10, y: 48 }, // 11 – upper left
    { x: 12, y: 32 }  // 12 – upper left (was spot 9)
  ];

  function buildDefaultHotspots(count) {
    var slots = [];
    for (var i = 0; i < count; i++) {
      var pos = DEFAULT_HOTSPOT_POSITIONS[i] || {
        x: Math.round(50 + 32 * Math.cos((i / count) * Math.PI * 2 - Math.PI / 2)),
        y: Math.round(50 + 32 * Math.sin((i / count) * Math.PI * 2 - Math.PI / 2))
      };
      slots.push({ id: String(i + 1), label: String(i + 1), x: pos.x, y: pos.y });
    }
    return slots;
  }

  // ─── FAVORITES ──────────────────────────────────────────────────────────────
  var FAV_KEY = 'charmbuilder_favorites';
  function getFavorites() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); } catch (_) { return []; }
  }
  function saveFavorites(ids) {
    try { localStorage.setItem(FAV_KEY, JSON.stringify(ids)); } catch (_) {}
  }
  function isFavorite(productId) { return getFavorites().indexOf(String(productId)) !== -1; }
  function toggleFavorite(productId) {
    var favs = getFavorites(), id = String(productId), idx = favs.indexOf(id);
    if (idx === -1) favs.push(id); else favs.splice(idx, 1);
    saveFavorites(favs);
    return idx === -1;
  }

  // ─── BUILDER STATE PERSISTENCE ──────────────────────────────────────────────
  var CB_STATE_KEY = 'charmbuilder_state';
  function saveBuilderState(selectedHolder, attachedCharms) {
    try {
      if (!selectedHolder) { localStorage.removeItem(CB_STATE_KEY); return; }
      localStorage.setItem(CB_STATE_KEY, JSON.stringify({
        holderData: selectedHolder,
        attachedCharms: attachedCharms
      }));
    } catch (_) {}
  }
  function loadBuilderState() {
    try { return JSON.parse(localStorage.getItem(CB_STATE_KEY) || 'null'); } catch (_) { return null; }
  }
  function clearBuilderState() {
    try { localStorage.removeItem(CB_STATE_KEY); } catch (_) {}
  }

  // ─── INIT ───────────────────────────────────────────────────────────────────

  function getConfig(sectionId) {
    var el = document.getElementById('CharmBuilderData-' + sectionId);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (_) { return null; }
  }

  function initSection(root) {
    var sectionId = (root.id || '').replace('charm-builder-', '');
    var config = getConfig(sectionId);
    if (!config) return;
    console.log('[CharmBuilder] config loaded — assemblyFeeVariantId:', config.assemblyFeeVariantId);

    // ── State ──────────────────────────────────────────────────────────────
    var state = {
      selectedHolder: null,
      attachedCharms: {},       // hotspotId → { productId, variantId, variantPrice, title, featuredImage, engravable, engraving }
      activeHotspotId: null,
      contextMenuHotspotId: null,
      engraveHotspotId: null,
      currentCharmDetail: null,
      selectedVariantId: null,
      selectedVariantPrice: 0,
      filters: { material: [], engravable: false, groups: {} },
      searchQuery: '',
      sortMode: 'featured',
      showFavoritesOnly: false,
      originalOrder: []
    };

    // ── Element refs ───────────────────────────────────────────────────────
    var $ = function (sel) { return root.querySelector(sel); };
    var mainImage       = $('#charm-builder-main-image');
    var placeholder     = $('#charm-builder-placeholder');
    var overlay         = $('#charm-builder-hotspot-overlay');
    var attachHint      = $('#charm-builder-attach-hint');
    var charmGrid       = $('#charm-builder-charm-grid');
    var doneBtn         = $('#charm-builder-add-to-cart');
    var doneText        = root.querySelector('.charm-builder-add-to-cart-text');
    var editBtn         = $('#charm-builder-edit-holder');
    var holderName      = $('#charm-builder-holder-name');
    var holderPrice     = $('#charm-builder-holder-price');
    var holderThumb     = $('#charm-builder-holder-thumb');
    var holderInfo      = $('#charm-builder-holder-selected-info');
    var holderOverlay   = $('#charm-builder-holder-overlay');
    var overlayClose    = $('#charm-builder-holder-overlay-close');
    var overlayBackdrop = $('#charm-builder-holder-overlay-backdrop');
    var charmDetail     = $('#charm-builder-charm-detail');
    var charmDetailContent = $('#charm-builder-charm-detail-content');
    var charmDetailClose = $('#charm-builder-charm-detail-close');
    var addToHolderBtn  = $('#charm-builder-add-to-holder-btn');
    var favoriteBtn     = $('#charm-builder-charm-add-favorite');
    var contextMenu     = $('#charm-builder-context-menu');
    var moveSubmenu     = $('#charm-builder-move-submenu');
    var moveOptions     = $('#charm-builder-move-options');
    var engravePanel    = $('#charm-builder-engrave-panel');
    var engraveContent  = $('#charm-builder-engrave-content');
    var engraveClose    = $('#charm-builder-engrave-close');
    var engraveApply    = $('#charm-builder-engrave-apply');
    var engraveRemove   = $('#charm-builder-engrave-remove');
    var filterBtn         = $('#charm-builder-filter-btn');
    var filterPanel       = $('#charm-builder-filter-panel');
    var filterBadge       = $('#charm-builder-filter-badge');
    var filterClear       = $('#charm-builder-filter-clear');
    var filterBody        = $('#charm-builder-filter-body');
    var activeFiltersRow  = $('#charm-builder-active-filters');
    var sortBtn         = $('#charm-builder-sort-btn');
    var sortDropdown    = $('#charm-builder-sort-dropdown');
    var searchInput     = $('#charm-builder-search');
    var productCount    = $('#charm-builder-product-count');
    var favsBtn         = $('#charm-builder-favorites-btn');
    var charmsToggle    = $('#charm-builder-charms-toggle');
    var charmsBody      = $('#charm-builder-charms-body');
    var subcolTabsWrap  = $('#charm-builder-subcol-tabs');
    var clearAllBtn     = $('#charm-builder-clear-all');
    var step1           = $('#charm-builder-step-1');
    var mainBody        = $('#charm-builder-main-body');
    var backdrop        = $('#charm-builder-backdrop');
    var slotCountEl     = $('#charm-builder-slot-count');
    var runningTotalEl  = $('#charm-builder-running-total');
    var toastEl         = $('#charm-builder-toast');

    // Store original card order
    if (charmGrid) {
      state.originalOrder = Array.from(charmGrid.querySelectorAll('.charm-builder-card--charm'));
    }

    // ── URL param auto-select (page mode) ─────────────────────────────────
    if (config.mode === 'page') {
      var params = new URLSearchParams(window.location.search);
      var holderHandle = params.get('holder');
      if (holderHandle) {
        var holderGridEl = $('#charm-builder-holder-grid') || root.querySelector('#charm-builder-holder-overlay-grid');
        if (holderGridEl) {
          var matchCard = holderGridEl.querySelector('[data-product-handle="' + holderHandle + '"]');
          if (matchCard) setTimeout(function () { selectHolder(matchCard); }, 0);
        }
      }
    }

    // ── Product mode auto-select ───────────────────────────────────────────
    if (config.mode === 'product' && config.preselectedHolder) {
      setTimeout(function () { applyHolder(config.preselectedHolder); }, 0);
    }

    // ── BUILD FILTERS ─────────────────────────────────────────────────────
    function buildFilters() {
      if (!filterBody && !filterPanel) return;
      var container = filterBody || filterPanel;
      if (!container) return;
      container.innerHTML = '';

      // 1. Material filter (from jewelry-material values on cards)
      if (charmGrid) {
        var materials = {};
        charmGrid.querySelectorAll('.charm-builder-card--charm').forEach(function (card) {
          var mat = (card.getAttribute('data-jewelry-material') || '').trim();
          if (mat) materials[mat] = true;
        });
        var matKeys = Object.keys(materials).sort();
        if (matKeys.length > 0) {
          container.appendChild(buildFilterGroup('Material', 'material', matKeys, 'material'));
        }
      }

      // 2. Metaobject-based tag groups — suffix/alias matching + pluralization dedup
      // fg.tags contains alias suffixes e.g. "charm,charms".
      // Tags whose last word matches an alias are grouped by normalized (singularized) prefix.
      // One chip per normalized group; clicking it filters by ALL variant fullTags in the group.
      var groups = Array.isArray(config.filterGroups) ? config.filterGroups : [];
      groups.forEach(function (fg) {
        if (!fg.label || !fg.tags) return;
        var aliases = fg.tags.split(',').map(function (a) { return a.trim().toLowerCase(); }).filter(Boolean);
        if (aliases.length === 0) return;

        // Singularize a lowercase word: strip trailing 's' if preceded by a consonant.
        function singularize(word) {
          if (word.length <= 2) return word;
          if (word[word.length - 1] !== 's') return word;
          var prev = word[word.length - 2];
          if ('aeiou'.indexOf(prev) !== -1 || prev === 's') return word;
          return word.slice(0, -1);
        }

        // normGroups: normKey → { label: normDisplay, fullTags: [] }
        var normGroups = {};
        if (charmGrid) {
          charmGrid.querySelectorAll('.charm-builder-card--charm').forEach(function (card) {
            var rawTags = (card.getAttribute('data-tags') || '').split('|');
            rawTags.forEach(function (rawTag) {
              var fullTag = rawTag.trim().toLowerCase();
              if (!fullTag) return;
              var parts = fullTag.replace(/[-_]/g, ' ').replace(/\s+/g, ' ').trim().split(' ');
              if (parts.length < 2) return;
              var lastWord = parts[parts.length - 1];
              if (aliases.indexOf(lastWord) === -1) return;
              var prefixParts = parts.slice(0, parts.length - 1);
              var normKey = prefixParts.map(singularize).join(' ');
              var normDisplay = prefixParts.map(function (p) {
                var s = singularize(p);
                return s.charAt(0).toUpperCase() + s.slice(1);
              }).join(' ');
              if (!normGroups[normKey]) {
                normGroups[normKey] = { label: normDisplay, fullTags: [] };
              }
              if (normGroups[normKey].fullTags.indexOf(fullTag) === -1) {
                normGroups[normKey].fullTags.push(fullTag);
              }
            });
          });
        }

        var entries = Object.keys(normGroups).sort(function (a, b) {
          return normGroups[a].label.localeCompare(normGroups[b].label);
        }).map(function (k) { return normGroups[k]; });

        if (entries.length === 0) return;
        if (!state.filters.groups[fg.key]) state.filters.groups[fg.key] = [];
        container.appendChild(buildAliasFilterGroup(fg.label, fg.key, entries));
      });

      // 3. Engraving filter toggle
      if (config.showEngravingFilter !== false) {
        var engSection = document.createElement('div');
        engSection.className = 'cb-filter-group';
        engSection.innerHTML =
          '<div class="cb-filter-group-title">Personalization</div>' +
          '<button type="button" class="cb-filter-toggle' + (state.filters.engravable ? ' active' : '') + '" id="cb-engravable-toggle">' +
            '<span class="cb-filter-toggle-track"><span class="cb-filter-toggle-thumb"></span></span>' +
            'Engravable Only' +
          '</button>';
        container.appendChild(engSection);
        var engToggle = engSection.querySelector('#cb-engravable-toggle');
        engToggle.addEventListener('click', function () {
          state.filters.engravable = !state.filters.engravable;
          engToggle.classList.toggle('active', state.filters.engravable);
          applyFiltersAndSort();
          updateFilterBadge();
        });
      }
    }

    // Builds a filter group. Each entry has { label, fullTags: [...] }.
    // One chip per normalized group; clicking adds/removes ALL fullTags (handles plural variants).
    function buildAliasFilterGroup(label, key, entries) {
      var section = document.createElement('div');
      section.className = 'cb-filter-group';
      var titleEl = document.createElement('div');
      titleEl.className = 'cb-filter-group-title';
      titleEl.textContent = label;
      section.appendChild(titleEl);
      var opts = document.createElement('div');
      opts.className = 'cb-filter-options';
      entries.forEach(function (entry) {
        var fullTags = Array.isArray(entry.fullTags) ? entry.fullTags : [entry.fullTag];
        // Restore active state from current filter state (survives panel rebuilds)
        var isActive = fullTags.some(function (ft) {
          return (state.filters.groups[key] || []).indexOf(ft) !== -1;
        });
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cb-filter-chip' + (isActive ? ' active' : '');
        btn.setAttribute('data-filter-type', 'group');
        btn.setAttribute('data-filter-key', key);
        btn.setAttribute('data-filter-value', fullTags[0]);
        btn.setAttribute('data-filter-label', entry.label);
        btn.textContent = entry.label;
        btn.addEventListener('click', function () {
          btn.classList.toggle('active');
          var arr = state.filters.groups[key] || [];
          var isActive = btn.classList.contains('active');
          fullTags.forEach(function (ft) {
            var gi = arr.indexOf(ft);
            if (isActive && gi === -1) arr.push(ft);
            else if (!isActive && gi !== -1) arr.splice(gi, 1);
          });
          state.filters.groups[key] = arr;
          applyFiltersAndSort();
          updateFilterBadge();
        });
        opts.appendChild(btn);
      });
      section.appendChild(opts);
      return section;
    }

    function buildFilterGroup(label, key, values, type) {
      var section = document.createElement('div');
      section.className = 'cb-filter-group';
      var titleEl = document.createElement('div');
      titleEl.className = 'cb-filter-group-title';
      titleEl.textContent = label;
      section.appendChild(titleEl);
      var opts = document.createElement('div');
      opts.className = 'cb-filter-options';
      values.forEach(function (val) {
        var displayVal = val.charAt(0).toUpperCase() + val.slice(1);
        // Restore active state from current filter state (survives panel rebuilds)
        var isActive = type === 'material'
          ? state.filters.material.indexOf(val) !== -1
          : (state.filters.groups[key] || []).indexOf(val) !== -1;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cb-filter-chip' + (isActive ? ' active' : '');
        btn.setAttribute('data-filter-type', type);
        btn.setAttribute('data-filter-key', key);
        btn.setAttribute('data-filter-value', val);
        btn.setAttribute('data-filter-label', displayVal);
        btn.textContent = displayVal;
        btn.addEventListener('click', function () {
          btn.classList.toggle('active');
          if (type === 'material') {
            var idx = state.filters.material.indexOf(val);
            if (idx === -1) state.filters.material.push(val); else state.filters.material.splice(idx, 1);
          } else {
            var arr = state.filters.groups[key] || [];
            var gi = arr.indexOf(val);
            if (gi === -1) arr.push(val); else arr.splice(gi, 1);
            state.filters.groups[key] = arr;
          }
          applyFiltersAndSort();
          updateFilterBadge();
        });
        opts.appendChild(btn);
      });
      section.appendChild(opts);
      return section;
    }

    function updateFilterBadge() {
      var count = state.filters.material.length + (state.filters.engravable ? 1 : 0);
      Object.values(state.filters.groups).forEach(function (arr) { count += arr.length; });
      if (filterBadge) {
        filterBadge.hidden = count === 0;
        filterBadge.textContent = count;
      }
      if (filterBtn) filterBtn.classList.toggle('active', count > 0);
      renderActiveFilters();
    }

    // ── ACTIVE FILTER CHIPS ────────────────────────────────────────────────
    // Renders removable pills above the grid showing each active filter.
    // Reads active chips from the filter panel DOM so labels stay in sync.
    function makeActiveChip(label, onRemove) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cb-active-filter-chip';
      btn.setAttribute('aria-label', 'Remove filter: ' + label);
      btn.innerHTML = esc(label) + '<span class="cb-active-filter-chip-x" aria-hidden="true">\u00d7</span>';
      btn.addEventListener('click', onRemove);
      return btn;
    }

    function renderActiveFilters() {
      if (!activeFiltersRow) return;
      activeFiltersRow.innerHTML = '';
      var hasAny = false;
      var panelContainer = filterBody || filterPanel;

      // Chips from filter panel: material + group tags (read active state from DOM)
      if (panelContainer) {
        panelContainer.querySelectorAll('.cb-filter-chip.active').forEach(function (panelBtn) {
          hasAny = true;
          var label = panelBtn.getAttribute('data-filter-label') || panelBtn.textContent.trim();
          // Capture reference for closure
          var capturedBtn = panelBtn;
          activeFiltersRow.appendChild(makeActiveChip(label, function () {
            // Toggle the panel chip off — its own click handler updates state + badge
            capturedBtn.click();
          }));
        });
      }

      // Engravable toggle (not a .cb-filter-chip, handled separately)
      if (state.filters.engravable) {
        hasAny = true;
        activeFiltersRow.appendChild(makeActiveChip('Engravable', function () {
          state.filters.engravable = false;
          if (panelContainer) {
            var engToggle = panelContainer.querySelector('#cb-engravable-toggle');
            if (engToggle) engToggle.classList.remove('active');
          }
          applyFiltersAndSort();
          updateFilterBadge();
        }));
      }

      activeFiltersRow.hidden = !hasAny;
    }

    // ── FILTER / SORT / SEARCH ─────────────────────────────────────────────
    function applyFiltersAndSort() {
      if (!charmGrid) return;
      var cards = Array.from(charmGrid.querySelectorAll('.charm-builder-card--charm'));
      var query = state.searchQuery.toLowerCase().trim();
      var favs = getFavorites();
      var visible = 0;

      cards.forEach(function (card) {
        var mat = (card.getAttribute('data-jewelry-material') || '').toLowerCase();
        var tags = (card.getAttribute('data-tags') || '').toLowerCase().split('|').map(function (t) { return t.trim(); });
        var title = (card.getAttribute('data-product-title') || '').toLowerCase();
        var engravable = card.getAttribute('data-engraving-enabled') === 'true' ||
                         card.getAttribute('data-engravable') === 'true';
        var productId = card.getAttribute('data-product-id');

        var ok = true;

        // Search
        if (query && !title.includes(query)) ok = false;

        // Favorites
        if (ok && state.showFavoritesOnly && favs.indexOf(productId) === -1) ok = false;

        // Material filter
        if (ok && state.filters.material.length > 0) {
          var matMatch = state.filters.material.some(function (m) {
            return mat.toLowerCase() === m.toLowerCase();
          });
          if (!matMatch) ok = false;
        }

        // Engraving filter
        if (ok && state.filters.engravable && !engravable) ok = false;

        // Group tag filters
        if (ok) {
          var groups = config.filterGroups || [];
          groups.forEach(function (fg) {
            if (!ok) return;
            var sel = state.filters.groups[fg.key];
            if (!sel || sel.length === 0) return;
            var cardHasTag = sel.some(function (tag) { return tags.indexOf(tag) !== -1; });
            if (!cardHasTag) ok = false;
          });
        }

        card.classList.toggle('charm-builder-card--hidden', !ok);
        if (ok) visible++;
      });

      if (productCount) {
        productCount.textContent = visible + ' Product' + (visible !== 1 ? 's' : '');
      }

      // Show / hide empty-state message
      var emptyMsg = charmGrid.querySelector('.charm-builder-empty');
      if (visible === 0) {
        if (!emptyMsg) {
          emptyMsg = document.createElement('p');
          emptyMsg.className = 'charm-builder-empty';
          emptyMsg.textContent = 'No charms match your selections — try different filters or search terms.';
          charmGrid.appendChild(emptyMsg);
        }
      } else if (emptyMsg) {
        emptyMsg.remove();
      }

      sortCards();
    }

    function sortCards() {
      if (!charmGrid) return;
      var frag = document.createDocumentFragment();
      if (state.sortMode === 'featured') {
        state.originalOrder.forEach(function (card) { frag.appendChild(card); });
        charmGrid.appendChild(frag);
        return;
      }
      var cards = Array.from(charmGrid.querySelectorAll('.charm-builder-card--charm'));
      cards.sort(function (a, b) {
        if (state.sortMode === 'price-asc' || state.sortMode === 'price-desc') {
          var pa = parseInt(a.getAttribute('data-variant-price'), 10) || 0;
          var pb = parseInt(b.getAttribute('data-variant-price'), 10) || 0;
          return state.sortMode === 'price-asc' ? pa - pb : pb - pa;
        }
        var ta = (a.getAttribute('data-product-title') || '').toLowerCase();
        var tb = (b.getAttribute('data-product-title') || '').toLowerCase();
        return state.sortMode === 'title-asc' ? ta.localeCompare(tb) : tb.localeCompare(ta);
      });
      cards.forEach(function (c) { frag.appendChild(c); });
      charmGrid.appendChild(frag);
    }

    // ── HOTSPOT RENDERING ──────────────────────────────────────────────────
    function getHotspots() {
      if (!state.selectedHolder) return [];
      var hs = state.selectedHolder.hotspots;
      if (!hs || !Array.isArray(hs) || hs.length === 0) {
        return buildDefaultHotspots(state.selectedHolder.maxCharms || config.defaultMaxCharms || 12);
      }
      return hs;
    }

    function renderHotspots() {
      if (!overlay) return;
      overlay.innerHTML = '';
      overlay.setAttribute('aria-hidden', 'false');
      var hotspots = getHotspots();

      // Compute bracelet centroid from actual hotspot positions so the outward
      // direction works for any bracelet image, not just the default layout.
      var cx = 0, cy = 0;
      hotspots.forEach(function (h) { cx += h.x; cy += h.y; });
      cx /= hotspots.length || 1;
      cy /= hotspots.length || 1;

      // Distance from hotspot centre to charm bubble centre:
      // hotspot radius (16px) + gap (6px) + charm bubble radius (26px) = 48px.
      var CHARM_OFFSET = 50; // px — slight extra clearance

      hotspots.forEach(function (h) {
        var id = String(h.id != null ? h.id : h.label);
        var label = String(h.label != null ? h.label : id);
        var charm = state.attachedCharms[id];
        var isActive = state.activeHotspotId === id;
        var isFilled = !!charm;

        var div = document.createElement('div');
        div.className = 'charm-builder-hotspot' +
          (isActive ? ' charm-builder-hotspot--active' : '') +
          (isFilled ? ' charm-builder-hotspot--filled' : '');
        div.setAttribute('data-hotspot-id', id);
        div.style.left = h.x + '%';
        div.style.top = h.y + '%';

        if (isFilled && charm.featuredImage) {
          // Number badge stays visible; charm image radiates outward from bracelet centre
          div.innerHTML =
            '<span class="charm-builder-hotspot-number">' + esc(label) + '</span>' +
            '<span class="charm-builder-hotspot-charm">' +
              '<img src="' + esc(charm.featuredImage) + '" alt="" class="charm-builder-hotspot-charm-img" width="60" height="60">' +
            '</span>';

          // Outward unit vector from bracelet centroid → this hotspot
          var dx = h.x - cx;
          var dy = h.y - cy;
          var len = Math.sqrt(dx * dx + dy * dy);
          if (len === 0) { dx = 0; dy = -1; } else { dx /= len; dy /= len; }

          var charmEl = div.querySelector('.charm-builder-hotspot-charm');
          if (charmEl) {
            charmEl.style.setProperty('--charm-out-x', (dx * CHARM_OFFSET).toFixed(1) + 'px');
            charmEl.style.setProperty('--charm-out-y', (dy * CHARM_OFFSET).toFixed(1) + 'px');
          }

          if (charm.engraving) {
            var badge = document.createElement('span');
            badge.className = 'charm-builder-hotspot-engrave-badge';
            badge.title = 'Engraved';
            badge.innerHTML = '<svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>';
            div.appendChild(badge);
          }
        } else {
          div.innerHTML = '<span class="charm-builder-hotspot-number">' + esc(label) + '</span>';
        }

        div.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (isFilled) {
            openContextMenu(e, id);
          } else {
            state.activeHotspotId = id;
            renderHotspots();
            if (attachHint) attachHint.hidden = false;
          }
        });

        overlay.appendChild(div);
      });

      updateSlotCount();
      updateDoneButton();
    }

    // ── HOLDER SELECTION ──────────────────────────────────────────────────
    function selectHolder(card) {
      var hotspots = parseJSON(card.getAttribute('data-hotspots'));
      var maxCharms = parseInt(card.getAttribute('data-max-charms'), 10) || config.defaultMaxCharms || 12;
      // Determine variant from card
      var variantId = card.getAttribute('data-variant-id');
      var variantPrice = parseInt(card.getAttribute('data-variant-price'), 10) || 0;
      var title = card.getAttribute('data-product-title') || card.querySelector('.charm-builder-card-title')?.textContent?.trim() || '';
      var featuredImage = card.getAttribute('data-featured-image');
      applyHolder({
        productId: card.getAttribute('data-product-id'),
        handle: card.getAttribute('data-product-handle'),
        title: title,
        featuredImage: featuredImage,
        variantId: variantId,
        variantPrice: variantPrice,
        material: card.getAttribute('data-material') || '',
        maxCharms: maxCharms,
        hotspots: hotspots
      });
    }

    function applyHolder(holderData) {
      state.selectedHolder = holderData;
      // Don't reset attachedCharms — charms persist across bracelet switches
      state.activeHotspotId = null;

      if (mainImage) {
        if (holderData.featuredImage) {
          mainImage.src = holderData.featuredImage;
          mainImage.alt = holderData.title || '';
          mainImage.classList.remove('hidden');
          if (placeholder) placeholder.hidden = true;
        } else {
          mainImage.classList.add('hidden');
          if (placeholder) {
            placeholder.hidden = false;
            var ptEl = placeholder.querySelector('.charm-builder-placeholder-text') || placeholder;
            ptEl.textContent = holderData.title || '';
          }
        }
      }

      if (holderName) holderName.textContent = holderData.title || '';
      if (holderPrice) holderPrice.textContent = formatMoney(holderData.variantPrice || 0, config.moneyFormat);
      if (holderThumb) {
        if (holderData.featuredImage) {
          holderThumb.src = holderData.featuredImage;
          holderThumb.alt = holderData.title || '';
          holderThumb.style.display = '';
          holderThumb.classList.remove('charm-builder-holder-thumb--placeholder');
        } else {
          holderThumb.src = '';
          holderThumb.style.display = 'none';
          holderThumb.classList.add('charm-builder-holder-thumb--placeholder');
        }
      }
      if (holderInfo) holderInfo.hidden = false;

      renderHotspots();
      // Reset favorites filter when switching bracelets
      state.showFavoritesOnly = false;
      if (favsBtn) {
        favsBtn.setAttribute('aria-pressed', 'false');
        favsBtn.classList.remove('active');
      }
      applyFiltersAndSort();
      updateDoneButton();
      closeHolderOverlay();

      if (step1) step1.hidden = true;
      if (mainBody) mainBody.classList.remove('charm-builder-body--hidden');

      saveBuilderState(state.selectedHolder, state.attachedCharms);
    }

    // ── HOLDER OVERLAY ─────────────────────────────────────────────────────
    function openHolderOverlay() {
      if (!holderOverlay) return;
      holderOverlay.hidden = false;
      if (backdrop) backdrop.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function closeHolderOverlay() {
      if (!holderOverlay) return;
      holderOverlay.hidden = true;
      if (backdrop && (charmDetail && charmDetail.hidden) && (engravePanel && engravePanel.hidden)) {
        backdrop.hidden = true;
        document.body.style.overflow = '';
      }
    }

    if (editBtn) editBtn.addEventListener('click', openHolderOverlay);
    if (overlayClose) overlayClose.addEventListener('click', closeHolderOverlay);
    if (overlayBackdrop) overlayBackdrop.addEventListener('click', closeHolderOverlay);

    function setupHolderGridListener(grid) {
      if (!grid) return;
      grid.addEventListener('click', function (e) {
        var card = e.target.closest('.charm-builder-card--holder');
        if (!card) return;
        selectHolder(card);
      });
      grid.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var card = e.target.closest('.charm-builder-card--holder');
        if (!card) return;
        e.preventDefault();
        selectHolder(card);
      });
    }

    var holderGrid = $('#charm-builder-holder-grid') || root.querySelector('#charm-builder-holder-overlay-grid');
    setupHolderGridListener(holderGrid);
    var overlayGrid = root.querySelector('#charm-builder-holder-overlay .charm-builder-grid, #charm-builder-holder-overlay-grid');
    if (overlayGrid && overlayGrid !== holderGrid) setupHolderGridListener(overlayGrid);

    // ── CHARM DETAIL PANEL ─────────────────────────────────────────────────
    function openCharmDetail(card) {
      var productId   = card.getAttribute('data-product-id');
      var variants    = parseJSON(card.getAttribute('data-variants')) || [];
      var options     = parseJSON(card.getAttribute('data-options')) || [];
      var images      = parseJSON(card.getAttribute('data-images')) || [];
      var title       = card.getAttribute('data-product-title') || '';
      var defaultVid  = card.getAttribute('data-variant-id');
      var defaultPrice = parseInt(card.getAttribute('data-variant-price'), 10) || 0;
      var engravable  = card.getAttribute('data-engraving-enabled') === 'true' ||
                        card.getAttribute('data-engravable') === 'true';
      var maxLines    = parseInt(card.getAttribute('data-max-engraving-lines'), 10) || 3;
      var charLimit   = parseInt(card.getAttribute('data-engraving-char-limit'), 10) || 12;
      var featuredImage = card.getAttribute('data-featured-image');

      state.currentCharmDetail = { productId, title, variants, options, images, featuredImage, defaultVid, defaultPrice, engravable, maxLines, charLimit };
      state.selectedVariantId   = defaultVid;
      state.selectedVariantPrice = defaultPrice;

      renderCharmDetailContent();

      if (charmDetail) charmDetail.hidden = false;
      if (backdrop) backdrop.hidden = false;
      document.body.style.overflow = 'hidden';
      updateDetailFavBtn(productId);

      // Scroll right panel to top on mobile
      if (charmDetail) charmDetail.scrollTop = 0;
    }

    function renderCharmDetailContent() {
      if (!charmDetailContent || !state.currentCharmDetail) return;
      var d = state.currentCharmDetail;
      var hideOptions = isDefaultVariant(d.variants.length ? d.variants : [{ title: 'Default Title' }]);

      // Image section with skeleton loader
      var imgSrc = (d.images && d.images.length > 0) ? d.images[0] : d.featuredImage;
      var thumbsHtml = '';
      if (d.images && d.images.length > 1) {
        thumbsHtml = '<div class="charm-detail-thumbs">' +
          d.images.map(function (src, i) {
            return '<button type="button" class="charm-detail-thumb' + (i === 0 ? ' active' : '') + '" data-img-src="' + esc(src) + '" aria-label="Image ' + (i + 1) + '">' +
              '<img src="' + esc(src) + '" alt="" width="56" height="56" loading="lazy">' +
              '</button>';
          }).join('') +
          '</div>';
      }
      var imagesHtml = imgSrc
        ? '<div class="charm-detail-media">' +
            '<div class="charm-detail-main-image-wrap">' +
              '<div class="charm-detail-img-skeleton" id="charm-detail-img-skeleton"></div>' +
              '<img class="charm-detail-main-image" id="charm-detail-main-img" src="' + esc(imgSrc) + '" alt="' + esc(d.title) + '" width="400" height="400" onload="this.previousElementSibling.style.display=\'none\';this.style.opacity=1">' +
            '</div>' + thumbsHtml +
          '</div>'
        : '';

      // Price
      var firstVariant = d.variants.find(function (v) { return String(v.id) === String(state.selectedVariantId); }) || d.variants[0];
      var priceStr = formatMoney(firstVariant ? firstVariant.price : d.defaultPrice, config.moneyFormat);

      // Options (skip if Default Title)
      var optionsHtml = '';
      if (!hideOptions && d.options && d.options.length > 0) {
        d.options.forEach(function (opt, optIdx) {
          var isColor = /metal|color|colour|finish/i.test(opt.name);
          optionsHtml += '<div class="charm-detail-option">';
          optionsHtml += '<div class="charm-detail-option-label">' + esc(opt.name) +
            ': <span class="charm-detail-option-val" data-opt-idx="' + optIdx + '">' + esc(opt.values[0] || '') + '</span></div>';

          if (isColor) {
            optionsHtml += '<div class="charm-detail-swatches" data-opt-name="' + esc(opt.name) + '">';
            opt.values.forEach(function (val) {
              var slug = val.toLowerCase().replace(/\s+/g, '-');
              optionsHtml += '<button type="button" class="charm-detail-swatch" data-option-name="' + esc(opt.name) + '" data-option-value="' + esc(val) + '" title="' + esc(val) + '" aria-label="' + esc(val) + '">' +
                '<span class="charm-detail-swatch-inner charm-detail-swatch--' + esc(slug) + '"></span></button>';
            });
            optionsHtml += '</div>';
          } else {
            optionsHtml += '<div class="charm-detail-option-grid" data-opt-name="' + esc(opt.name) + '">';
            opt.values.forEach(function (val) {
              optionsHtml += '<button type="button" class="charm-detail-option-btn" data-option-name="' + esc(opt.name) + '" data-option-value="' + esc(val) + '">' + esc(val) + '</button>';
            });
            optionsHtml += '</div>';
          }
          optionsHtml += '</div>';
        });
      }

      charmDetailContent.innerHTML =
        imagesHtml +
        '<div class="charm-detail-info">' +
          '<h3 class="charm-detail-title">' + esc(d.title) + '</h3>' +
          '<div class="charm-detail-price" id="charm-detail-price">' + esc(priceStr) + '</div>' +
          optionsHtml +
        '</div>';

      wireOptionButtons();
      wireThumbButtons();

      // Mark first option as selected
      if (!hideOptions && d.options) {
        d.options.forEach(function (opt) {
          var first = charmDetailContent.querySelector('[data-option-name="' + opt.name + '"]');
          if (first) first.classList.add('selected');
        });
      }
    }

    function wireThumbButtons() {
      if (!charmDetailContent) return;
      var mainImg = charmDetailContent.querySelector('#charm-detail-main-img');
      charmDetailContent.querySelectorAll('.charm-detail-thumb').forEach(function (btn) {
        btn.addEventListener('click', function () {
          charmDetailContent.querySelectorAll('.charm-detail-thumb').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          if (mainImg) {
            var skeleton = charmDetailContent.querySelector('#charm-detail-img-skeleton');
            if (skeleton) skeleton.style.display = '';
            mainImg.style.opacity = '0';
            mainImg.src = btn.getAttribute('data-img-src');
          }
        });
      });
    }

    function wireOptionButtons() {
      if (!charmDetailContent || !state.currentCharmDetail) return;
      var d = state.currentCharmDetail;
      charmDetailContent.querySelectorAll('[data-option-name]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var optName = btn.getAttribute('data-option-name');
          charmDetailContent.querySelectorAll('[data-option-name="' + optName + '"]').forEach(function (s) { s.classList.remove('selected'); });
          btn.classList.add('selected');
          var optIdx = d.options.findIndex(function (o) { return o.name === optName; });
          var lbl = charmDetailContent.querySelector('[data-opt-idx="' + optIdx + '"]');
          if (lbl) lbl.textContent = btn.getAttribute('data-option-value');
          updateSelectedVariant();
        });
      });
    }

    function updateSelectedVariant() {
      if (!state.currentCharmDetail) return;
      var d = state.currentCharmDetail;
      if (!d.options || d.options.length === 0 || d.variants.length === 0) return;
      var selected = {};
      d.options.forEach(function (opt) {
        var btn = charmDetailContent.querySelector('[data-option-name="' + opt.name + '"].selected');
        if (btn) selected[opt.name] = btn.getAttribute('data-option-value');
      });
      var match = d.variants.find(function (v) {
        return d.options.every(function (opt, i) { return v.options && v.options[i] === selected[opt.name]; });
      });
      if (match) {
        state.selectedVariantId = String(match.id);
        state.selectedVariantPrice = match.price;
        var priceEl = charmDetailContent.querySelector('#charm-detail-price');
        if (priceEl) priceEl.textContent = formatMoney(match.price, config.moneyFormat);
        if (match.featured_image) {
          var mainImg = charmDetailContent.querySelector('#charm-detail-main-img');
          if (mainImg) {
            var skeleton = charmDetailContent.querySelector('#charm-detail-img-skeleton');
            if (skeleton) skeleton.style.display = '';
            mainImg.style.opacity = '0';
            mainImg.src = match.featured_image;
          }
        }
      }
    }

    function updateDetailFavBtn(productId) {
      if (!favoriteBtn) return;
      var fav = isFavorite(productId);
      favoriteBtn.classList.toggle('charm-builder-favorite-btn--active', fav);
      var span = favoriteBtn.querySelector('span') || favoriteBtn;
      if (favoriteBtn.querySelector('span')) favoriteBtn.querySelector('span').textContent = fav ? 'Saved to Favorites' : 'Add to Your Favorites';
    }

    function closeCharmDetail() {
      if (charmDetail) charmDetail.hidden = true;
      if (!holderOverlay || holderOverlay.hidden) {
        if (backdrop) backdrop.hidden = true;
        document.body.style.overflow = '';
      }
      state.currentCharmDetail = null;
    }

    if (charmDetailClose) charmDetailClose.addEventListener('click', closeCharmDetail);

    // Add to Holder
    if (addToHolderBtn) {
      addToHolderBtn.addEventListener('click', function () {
        if (!state.currentCharmDetail || state.activeHotspotId == null) return;
        var d = state.currentCharmDetail;
        var variantId = parseInt(state.selectedVariantId || d.defaultVid, 10);
        if (!variantId || isNaN(variantId)) {
          alert('Please select a valid option before adding to your bracelet.');
          return;
        }
        var price = state.selectedVariantPrice || d.defaultPrice;
        var imgEl = charmDetailContent && (charmDetailContent.querySelector('#charm-detail-main-img') || charmDetailContent.querySelector('.charm-detail-main-image'));
        var img = (imgEl && imgEl.src) || d.featuredImage;

        state.attachedCharms[state.activeHotspotId] = {
          productId: d.productId,
          title: d.title,
          variantId: String(variantId),
          variantPrice: price,
          featuredImage: img,
          engravable: d.engravable,
          engraving: null
        };
        state.activeHotspotId = null;
        if (attachHint) attachHint.hidden = true;
        renderHotspots();
        updateDoneButton();
        saveBuilderState(state.selectedHolder, state.attachedCharms);
        closeCharmDetail();
      });
    }

    // Favorites
    if (favoriteBtn) {
      favoriteBtn.addEventListener('click', function () {
        if (!state.currentCharmDetail) return;
        toggleFavorite(state.currentCharmDetail.productId);
        updateDetailFavBtn(state.currentCharmDetail.productId);
        if (state.showFavoritesOnly) applyFiltersAndSort();
      });
    }

    // Charm grid click → open detail
    if (charmGrid) {
      charmGrid.addEventListener('click', function (e) {
        var card = e.target.closest('.charm-builder-card--charm');
        if (!card || card.classList.contains('charm-builder-card--hidden')) return;
        if (card.classList.contains('charm-builder-card--sold-out')) return; // block sold-out charms
        if (!state.selectedHolder) {
          showToast('Pick a bracelet first \u2014 use the Edit button above');
          return;
        }
        if (state.activeHotspotId == null) {
          var hotspots = getHotspots();
          var firstEmpty = hotspots.find(function (h) { return !state.attachedCharms[String(h.id)]; });
          if (firstEmpty) {
            state.activeHotspotId = String(firstEmpty.id);
            renderHotspots();
            if (attachHint) attachHint.hidden = false;
          } else {
            showToast('All slots are filled! Remove a charm to swap it.');
            return;
          }
        }
        openCharmDetail(card);
      });
      charmGrid.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var card = e.target.closest('.charm-builder-card--charm');
        if (card && !card.classList.contains('charm-builder-card--hidden') && !card.classList.contains('charm-builder-card--sold-out') && state.selectedHolder) {
          e.preventDefault(); openCharmDetail(card);
        }
      });
    }

    // ── CONTEXT MENU ──────────────────────────────────────────────────────
    function openContextMenu(e, hotspotId) {
      if (!contextMenu) return;
      state.contextMenuHotspotId = hotspotId;
      if (moveSubmenu) moveSubmenu.hidden = true;

      var charm = state.attachedCharms[hotspotId];

      // Show/hide engrave based on charm's engravable flag
      var engraveItem = contextMenu.querySelector('[data-action="engrave"]');
      if (engraveItem) engraveItem.style.display = (charm && charm.engravable) ? '' : 'none';

      // Position the menu near the hotspot circle
      var x = e.clientX, y = e.clientY;
      var hotspotEl = overlay && overlay.querySelector('[data-hotspot-id="' + hotspotId + '"]');
      if (hotspotEl) {
        var hr = hotspotEl.getBoundingClientRect();
        x = hr.right + 8;
        y = hr.top;
      }
      // Keep within viewport
      contextMenu.style.left = '';
      contextMenu.style.right = '';
      contextMenu.style.top = '';
      contextMenu.hidden = false; // show first to measure
      var cw = contextMenu.offsetWidth || 180;
      var ch = contextMenu.offsetHeight || 150;
      if (x + cw > window.innerWidth - 8) x = window.innerWidth - cw - 8;
      if (y + ch > window.innerHeight - 8) y = window.innerHeight - ch - 8;
      if (x < 8) x = 8;
      if (y < 8) y = 8;
      contextMenu.style.left = x + 'px';
      contextMenu.style.top = y + 'px';
      if (backdrop) backdrop.hidden = false;
    }

    function closeContextMenu() {
      if (contextMenu) contextMenu.hidden = true;
      if (moveSubmenu) moveSubmenu.hidden = true;
      if (!charmDetail || charmDetail.hidden) {
        if (!holderOverlay || holderOverlay.hidden) {
          if (!engravePanel || engravePanel.hidden) {
            if (backdrop) backdrop.hidden = true;
            document.body.style.overflow = '';
          }
        }
      }
      state.contextMenuHotspotId = null;
    }

    if (contextMenu) {
      contextMenu.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-action]');
        if (!btn) return;
        var action = btn.getAttribute('data-action');
        var hid = state.contextMenuHotspotId;
        if (action === 'remove') {
          delete state.attachedCharms[hid];
          state.activeHotspotId = null;
          renderHotspots();
          updateDoneButton();
          saveBuilderState(state.selectedHolder, state.attachedCharms);
          closeContextMenu();
        } else if (action === 'move') {
          if (!moveSubmenu || !moveOptions) return;
          var hotspots = getHotspots();
          moveOptions.innerHTML = '';
          hotspots.forEach(function (h) {
            var id = String(h.id);
            if (id === hid) return;
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'cb-move-option' + (state.attachedCharms[id] ? ' cb-move-option--occupied' : '');
            b.textContent = 'Slot ' + h.label + (state.attachedCharms[id] ? ' (swap)' : '');
            b.addEventListener('click', function () {
              var fromCharm = state.attachedCharms[hid];
              if (state.attachedCharms[id]) {
                var toCharm = state.attachedCharms[id];
                state.attachedCharms[id] = fromCharm;
                state.attachedCharms[hid] = toCharm;
              } else {
                state.attachedCharms[id] = fromCharm;
                delete state.attachedCharms[hid];
              }
              renderHotspots();
              updateDoneButton();
              saveBuilderState(state.selectedHolder, state.attachedCharms);
              closeContextMenu();
            });
            moveOptions.appendChild(b);
          });
          moveSubmenu.hidden = false;
        } else if (action === 'engrave') {
          closeContextMenu();
          openEngravePanel(hid);
        }
      });
    }

    // ── ENGRAVE PANEL ─────────────────────────────────────────────────────
    function openEngravePanel(hotspotId) {
      if (!engravePanel || !engraveContent) return;
      var charm = state.attachedCharms[hotspotId];
      if (!charm || !charm.engravable) return;
      state.engraveHotspotId = hotspotId;

      var card = charmGrid && charmGrid.querySelector('[data-product-id="' + charm.productId + '"]');
      var engConfig = card ? parseJSON(card.getAttribute('data-engraving-config')) : null;
      var existing = charm.engraving || {};
      var activeTypeKey = existing.typeKey || (engConfig && engConfig.defaultTypeKey) || 'default';

      function getActiveType() {
        if (!engConfig || !engConfig.engravingTypes || engConfig.engravingTypes.length === 0) return null;
        return engConfig.engravingTypes.find(function (t) { return t.key === activeTypeKey; }) || engConfig.engravingTypes[0];
      }

      function buildLineInputs(count, charLimit, sideNum, existingLines) {
        var html = '';
        for (var i = 1; i <= count; i++) {
          var val = (existingLines && existingLines[i - 1]) || '';
          html +=
            '<div class="cb-engrave-line">' +
              '<label class="cb-engrave-line-label">Line ' + i + '</label>' +
              '<div class="cb-engrave-line-row">' +
                '<input type="text" class="cb-engrave-input" data-line="' + i + '" data-side="' + sideNum + '" maxlength="' + charLimit + '" value="' + esc(val) + '" placeholder="Enter text\u2026" autocomplete="off">' +
                '<span class="cb-engrave-count"><span class="cb-engrave-used">' + val.length + '</span>/' + charLimit + '</span>' +
              '</div>' +
            '</div>';
        }
        return html;
      }

      function renderPanel() {
        var activeType = getActiveType();
        var maxLines   = activeType ? (activeType.maxLines || 1) : (card ? parseInt(card.getAttribute('data-max-engraving-lines'), 10) || 3 : 3);
        var charLimit  = activeType ? (activeType.characterLimitPerLine || 12) : (card ? parseInt(card.getAttribute('data-engraving-char-limit'), 10) || 12 : 12);
        var allowSide2 = activeType ? !!activeType.allowSecondSide : false;
        var fonts      = (activeType && activeType.fonts && activeType.fonts.length) ? activeType.fonts : [
          { label: 'Script', value: 'script', cssFontFamily: 'Georgia, serif' },
          { label: 'Sans',   value: 'sans',   cssFontFamily: 'inherit' }
        ];
        var selectedFontVal = existing.fontValue || fonts[0].value;
        var selectedFont    = fonts.find(function (f) { return f.value === selectedFontVal; }) || fonts[0];

        // Type selector (only when multiple types exist)
        var typeHtml = '';
        if (engConfig && engConfig.engravingTypes && engConfig.engravingTypes.length > 1) {
          typeHtml = '<div class="cb-engrave-types">' +
            engConfig.engravingTypes.map(function (t) {
              return '<button type="button" class="cb-engrave-type-btn' + (t.key === activeTypeKey ? ' selected' : '') + '" data-type-key="' + esc(t.key) + '">' + esc(t.title) + '</button>';
            }).join('') +
            '</div>';
        }

        // Side 2 inputs
        var side2Html = '';
        if (allowSide2) {
          side2Html =
            '<div class="cb-engrave-side2-wrap">' +
              '<div class="cb-engrave-section-label">Second Side <span class="cb-engrave-optional">(optional)</span></div>' +
              '<div class="cb-engrave-lines">' + buildLineInputs(maxLines, charLimit, 2, existing.side2Lines) + '</div>' +
            '</div>';
        }

        // Font buttons
        var fontBtns = fonts.map(function (f) {
          return '<button type="button" class="cb-font-btn' + (f.value === selectedFontVal ? ' selected' : '') + '" ' +
            'data-font-value="' + esc(f.value) + '" data-font-label="' + esc(f.label) + '" data-font-css="' + esc(f.cssFontFamily || 'inherit') + '" ' +
            'style="font-family:' + esc(f.cssFontFamily || 'inherit') + '">' + esc(f.label) + '</button>';
        }).join('');

        var previewLine = (existing.lines && existing.lines[0]) || '';
        var side1Label = allowSide2 ? '<div class="cb-engrave-section-label">Side 1</div>' : '';

        engraveContent.innerHTML =
          '<p class="cb-engrave-for">Engraving for <strong>' + esc(charm.title) + '</strong></p>' +
          typeHtml +
          side1Label +
          '<div class="cb-engrave-lines" id="cb-engrave-side1-lines">' + buildLineInputs(maxLines, charLimit, 1, existing.lines) + '</div>' +
          side2Html +
          '<div class="cb-engrave-fonts-section"><div class="cb-engrave-fonts-label">Font</div><div class="cb-engrave-fonts">' + fontBtns + '</div></div>' +
          '<div class="cb-engrave-preview"><div class="cb-engrave-preview-label">Preview</div>' +
            '<div class="cb-engrave-preview-text" id="cb-engrave-preview" style="font-family:' + esc(selectedFont.cssFontFamily || 'inherit') + '">' + esc(previewLine) + '</div>' +
          '</div>';

      }

      // ── Event delegation (set up ONCE per panel open, not per renderPanel) ──
      // Remove any handlers from a previous charm's panel open.
      if (engraveContent._cbInputHandler) {
        engraveContent.removeEventListener('input', engraveContent._cbInputHandler);
        engraveContent.removeEventListener('click', engraveContent._cbClickHandler);
      }

      function onEngraveInput(e) {
        var inp = e.target;
        if (!inp.classList.contains('cb-engrave-input')) return;
        var lineEl = inp.closest('.cb-engrave-line');
        var used = lineEl && lineEl.querySelector('.cb-engrave-used');
        if (used) used.textContent = inp.value.length;
        if (inp.getAttribute('data-side') === '1' && inp.getAttribute('data-line') === '1') {
          var previewEl = engraveContent.querySelector('#cb-engrave-preview');
          if (previewEl) previewEl.textContent = inp.value;
        }
      }

      function onEngraveClick(e) {
        var typeBtn = e.target.closest && e.target.closest('.cb-engrave-type-btn');
        if (typeBtn) {
          activeTypeKey = typeBtn.getAttribute('data-type-key');
          existing = {};
          renderPanel();
          return;
        }
        var fontBtn = e.target.closest && e.target.closest('.cb-font-btn');
        if (fontBtn) {
          engraveContent.querySelectorAll('.cb-font-btn').forEach(function (b) { b.classList.remove('selected'); });
          fontBtn.classList.add('selected');
          var previewEl = engraveContent.querySelector('#cb-engrave-preview');
          if (previewEl) previewEl.style.fontFamily = fontBtn.getAttribute('data-font-css') || 'inherit';
        }
      }

      engraveContent._cbInputHandler = onEngraveInput;
      engraveContent._cbClickHandler = onEngraveClick;
      engraveContent.addEventListener('input', onEngraveInput);
      engraveContent.addEventListener('click', onEngraveClick);

      renderPanel();

      if (engraveRemove) engraveRemove.hidden = !charm.engraving;
      engravePanel.hidden = false;
      if (backdrop) backdrop.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeEngravePanel() {
      if (engravePanel) engravePanel.hidden = true;
      if (backdrop) backdrop.hidden = true;
      document.body.style.overflow = '';
      state.engraveHotspotId = null;
    }

    if (engraveClose) engraveClose.addEventListener('click', closeEngravePanel);
    if (engraveApply) {
      engraveApply.addEventListener('click', function () {
        var hid = state.engraveHotspotId;
        if (hid == null || !state.attachedCharms[hid]) return;

        // Collect side 1 lines
        var lines = [];
        engraveContent.querySelectorAll('.cb-engrave-input[data-side="1"]').forEach(function (inp) {
          lines.push(inp.value.trim());
        });

        // Collect side 2 lines
        var side2Lines = [];
        engraveContent.querySelectorAll('.cb-engrave-input[data-side="2"]').forEach(function (inp) {
          side2Lines.push(inp.value.trim());
        });

        // Font
        var fontBtn = engraveContent.querySelector('.cb-font-btn.selected');
        var fontValue = fontBtn ? fontBtn.getAttribute('data-font-value') : 'script';
        var fontLabel = fontBtn ? fontBtn.getAttribute('data-font-label') : 'Script';
        var fontCss   = fontBtn ? fontBtn.getAttribute('data-font-css') : 'inherit';

        // Active type key and variant IDs from config
        var charm = state.attachedCharms[hid];
        var card = charmGrid && charmGrid.querySelector('[data-product-id="' + charm.productId + '"]');
        var engConfig = card ? parseJSON(card.getAttribute('data-engraving-config')) : null;
        var typeBtnEl = engraveContent.querySelector('.cb-engrave-type-btn.selected');
        var activeTypeKey = typeBtnEl ? typeBtnEl.getAttribute('data-type-key')
          : (engConfig && engConfig.defaultTypeKey) || 'default';
        var activeType = (engConfig && engConfig.engravingTypes)
          ? (engConfig.engravingTypes.find(function (t) { return t.key === activeTypeKey; }) || engConfig.engravingTypes[0])
          : null;
        var baseVariantId      = activeType ? (activeType.variantIds && activeType.variantIds.baseEngraving)  : null;
        var secondSideVariantId = activeType ? (activeType.variantIds && activeType.variantIds.secondSide) : null;

        var hasText  = lines.some(function (l) { return l; });
        var hasSide2 = side2Lines.some(function (l) { return l; });

        state.attachedCharms[hid].engraving = hasText ? {
          typeKey:            activeTypeKey,
          lines:              lines,
          side2Lines:         hasSide2 ? side2Lines : [],
          fontValue:          fontValue,
          fontLabel:          fontLabel,
          fontCss:            fontCss,
          baseVariantId:      baseVariantId,
          secondSideVariantId: hasSide2 ? secondSideVariantId : null
        } : null;

        saveBuilderState(state.selectedHolder, state.attachedCharms);
        renderHotspots();
        closeEngravePanel();
      });
    }
    if (engraveRemove) {
      engraveRemove.addEventListener('click', function () {
        var hid = state.engraveHotspotId;
        if (hid != null && state.attachedCharms[hid]) state.attachedCharms[hid].engraving = null;
        saveBuilderState(state.selectedHolder, state.attachedCharms);
        renderHotspots();
        closeEngravePanel();
      });
    }

    // ── FILTER / SORT WIRING ───────────────────────────────────────────────
    if (filterBtn) {
      filterBtn.addEventListener('click', function () {
        if (!filterPanel) return;
        var open = !filterPanel.hidden;
        filterPanel.hidden = open;
        filterBtn.setAttribute('aria-expanded', !open ? 'true' : 'false');
      });
    }
    if (filterClear) {
      filterClear.addEventListener('click', function () {
        state.filters = { material: [], engravable: false, groups: {} };
        var container = filterBody || filterPanel;
        if (container) {
          container.querySelectorAll('.cb-filter-chip').forEach(function (b) { b.classList.remove('active'); });
          var engToggle = container.querySelector('#cb-engravable-toggle');
          if (engToggle) engToggle.classList.remove('active');
        }
        // Also reset search
        state.searchQuery = '';
        if (searchInput) searchInput.value = '';
        // Also reset sort to featured
        state.sortMode = 'featured';
        if (sortDropdown) {
          sortDropdown.querySelectorAll('.charm-builder-sort-option').forEach(function (b) {
            var isFeatured = b.getAttribute('data-sort') === 'featured';
            b.classList.toggle('selected', isFeatured);
            b.setAttribute('aria-selected', isFeatured ? 'true' : 'false');
          });
        }
        // Also reset favorites
        state.showFavoritesOnly = false;
        if (favsBtn) {
          favsBtn.setAttribute('aria-pressed', 'false');
          favsBtn.classList.remove('active');
        }
        applyFiltersAndSort();
        updateFilterBadge();
      });
    }
    // Portal sort dropdown to <body> so it escapes overflow-clipping ancestors
    if (sortDropdown) {
      document.body.appendChild(sortDropdown);
    }

    function positionSortDropdown() {
      if (!sortBtn || !sortDropdown) return;
      var r = sortBtn.getBoundingClientRect();
      sortDropdown.style.top  = (r.bottom + 6) + 'px';
      sortDropdown.style.left = r.left + 'px';
      // Keep within viewport on the right
      var ddWidth = sortDropdown.offsetWidth || 190;
      if (r.left + ddWidth > window.innerWidth - 8) {
        sortDropdown.style.left = Math.max(8, window.innerWidth - ddWidth - 8) + 'px';
      }
    }

    function closeSortDropdown() {
      if (!sortDropdown) return;
      sortDropdown.hidden = true;
      if (sortBtn) sortBtn.setAttribute('aria-expanded', 'false');
    }

    if (sortBtn) {
      sortBtn.addEventListener('click', function () {
        if (!sortDropdown) return;
        var open = !sortDropdown.hidden;
        if (open) {
          closeSortDropdown();
        } else {
          sortDropdown.hidden = false;
          positionSortDropdown();
          sortBtn.setAttribute('aria-expanded', 'true');
        }
      });
    }
    if (sortDropdown) {
      sortDropdown.addEventListener('click', function (e) {
        var btn = e.target.closest('.charm-builder-sort-option');
        if (!btn) return;
        sortDropdown.querySelectorAll('.charm-builder-sort-option').forEach(function (b) {
          b.classList.remove('selected'); b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('selected'); btn.setAttribute('aria-selected', 'true');
        state.sortMode = btn.getAttribute('data-sort');
        closeSortDropdown();
        applyFiltersAndSort();
      });
    }
    var searchDebounceTimer = null;
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        state.searchQuery = searchInput.value;
        clearTimeout(searchDebounceTimer);
        searchDebounceTimer = setTimeout(applyFiltersAndSort, 150);
      });
    }
    if (favsBtn) {
      favsBtn.addEventListener('click', function () {
        state.showFavoritesOnly = !state.showFavoritesOnly;
        favsBtn.setAttribute('aria-pressed', state.showFavoritesOnly ? 'true' : 'false');
        favsBtn.classList.toggle('active', state.showFavoritesOnly);
        applyFiltersAndSort();
      });
    }
    if (charmsToggle && charmsBody) {
      charmsToggle.addEventListener('click', function () {
        var expanded = charmsToggle.getAttribute('aria-expanded') === 'true';
        charmsToggle.setAttribute('aria-expanded', !expanded ? 'true' : 'false');
        charmsBody.classList.toggle('charm-builder-charms-body--collapsed', expanded);
        charmsToggle.querySelector('.charm-builder-accordion-icon').style.transform = expanded ? 'rotate(-90deg)' : '';
      });
    }

    // ── CLEAR ALL ─────────────────────────────────────────────────────────────
    function clearAll() {
      if (Object.keys(state.attachedCharms).length === 0) return;
      if (!confirm('Remove all charms from your bracelet?')) return;
      state.attachedCharms = {};
      state.activeHotspotId = null;
      renderHotspots();
      updateDoneButton();
      saveBuilderState(state.selectedHolder, state.attachedCharms);
    }
    if (clearAllBtn) clearAllBtn.addEventListener('click', clearAll);

    // ── DONE / ADD TO CART ─────────────────────────────────────────────────
    function updateDoneButton() {
      if (!doneBtn) return;
      var hasHolder = !!state.selectedHolder;
      doneBtn.disabled = !hasHolder;
      var total = 0;
      if (state.selectedHolder) total += (state.selectedHolder.variantPrice || 0);
      Object.values(state.attachedCharms).forEach(function (c) { if (c && c.variantPrice) total += c.variantPrice; });
      if (doneText) doneText.textContent = 'Done' + (hasHolder ? ' \u2014 ' + formatMoney(total, config.moneyFormat) : '');
    }

    // ── SLOT COUNT ────────────────────────────────────────────────────────────
    function updateSlotCount() {
      if (!slotCountEl) return;
      if (!state.selectedHolder) { slotCountEl.hidden = true; return; }
      var total = getHotspots().length;
      var filled = Object.keys(state.attachedCharms).length;
      slotCountEl.textContent = filled + '\u202f/\u202f' + total + '\u00a0charms';
      slotCountEl.hidden = false;
      // Visually highlight when all slots are filled
      slotCountEl.classList.toggle('cb-slot-count--full', filled >= total && total > 0);
    }

    // ── TOAST NOTIFICATION ────────────────────────────────────────────────────
    var _toastTimer = null;
    function showToast(msg, duration) {
      if (!toastEl) return;
      toastEl.textContent = msg;
      toastEl.classList.add('cb-toast--active');
      clearTimeout(_toastTimer);
      _toastTimer = setTimeout(function () {
        toastEl.classList.remove('cb-toast--active');
      }, duration || 2500);
    }

    if (doneBtn) doneBtn.addEventListener('click', addToCart);

    function addToCart() {
      if (!state.selectedHolder || (doneBtn && doneBtn.disabled)) return;
      var holderVid = parseInt(state.selectedHolder.variantId, 10);
      if (!holderVid) { alert('Bracelet selection is invalid. Please re-select your bracelet.'); return; }

      var sessionId = uid();
      // Short human-readable build code shown visibly on all line items so staff
      // can instantly tell which charms belong to which bracelet in an order.
      var buildCode = '#' + sessionId.slice(0, 6).toUpperCase();
      var braceletTitle = state.selectedHolder.title;
      var hotspots = getHotspots();
      var totalSlots = hotspots.length;

      // ── Bracelet line item ────────────────────────────────────────────────
      // Visible properties first (no underscore) — shown in cart + order emails.
      // Underscore properties are hidden from customers but visible in admin.
      var holderProps = {
        'Build': buildCode,                   // ties bracelet ↔ charms visibly
        '_builder_session': sessionId         // programmatic grouping key
      };
      // Snapshot each filled slot as a summary on the bracelet item
      hotspots.forEach(function (h) {
        var charm = state.attachedCharms[String(h.id)];
        if (charm) holderProps['Slot ' + h.label] = charm.title;
      });

      var items = [{ id: holderVid, quantity: 1, properties: holderProps }];

      // ── Assembly fee ──────────────────────────────────────────────────────
      // One per build. Properties mirror the bracelet so cascade removal works
      // and so it groups visually with the bracelet in the cart.
      if (!config.assemblyFeeVariantId) {
        console.warn('[CharmBuilder] assemblyFeeVariantId not configured — set "Bracelet assembly fee product" in Theme Settings → Cart.');
      }
      if (config.assemblyFeeVariantId) {
        items.push({
          id: parseInt(config.assemblyFeeVariantId, 10),
          quantity: 1,
          properties: {
            'Build': buildCode,
            'Bracelet': braceletTitle,
            '_builder_session': sessionId,
            '_assembly_fee': '1'
          }
        });
      }

      // ── Charm + engraving fee line items ──────────────────────────────────
      Object.keys(state.attachedCharms).sort(function (a, b) { return Number(a) - Number(b); }).forEach(function (hid) {
        var charm = state.attachedCharms[hid];
        if (!charm || !charm.variantId) return;
        var vid = parseInt(charm.variantId, 10);
        if (!vid) return;
        var hotspot = hotspots.find(function (h) { return String(h.id) === hid; });
        var slotLabel = hotspot ? hotspot.label : hid;

        var props = {
          // Visible: clearly associates charm → bracelet for customer + staff
          'Bracelet': braceletTitle,
          'Slot': slotLabel + ' of ' + totalSlots,
          'Build': buildCode,
          // Hidden: programmatic references for order management / apps
          '_bracelet_variant': String(holderVid),
          '_builder_session': sessionId
        };

        if (charm.engraving) {
          if (charm.engraving.lines) {
            charm.engraving.lines.forEach(function (line, idx) {
              if (line) props['Engraving Line ' + (idx + 1)] = line;
            });
          } else {
            for (var i = 1; i <= 3; i++) {
              if (charm.engraving['line' + i]) props['Engraving Line ' + i] = charm.engraving['line' + i];
            }
          }
          if (charm.engraving.fontLabel) props['Engraving Font'] = charm.engraving.fontLabel;
          else if (charm.engraving.font) props['Engraving Font'] = charm.engraving.font;
        }
        items.push({ id: vid, quantity: 1, properties: props });

        // Engraving fee line items (separate products from metaobject variantIds)
        if (charm.engraving && charm.engraving.baseVariantId) {
          var engFeeProps = {
            'For Charm': charm.title,
            'Bracelet': braceletTitle,
            'Slot': slotLabel + ' of ' + totalSlots,
            'Build': buildCode,
            '_bracelet_variant': String(holderVid),
            '_builder_session': sessionId
          };
          charm.engraving.lines.forEach(function (line, idx) {
            if (line) engFeeProps['Engraving Line ' + (idx + 1)] = line;
          });
          if (charm.engraving.fontLabel) engFeeProps['Font'] = charm.engraving.fontLabel;
          if (charm.engraving.typeKey && charm.engraving.typeKey !== 'default') engFeeProps['Type'] = charm.engraving.typeKey;
          items.push({ id: parseInt(charm.engraving.baseVariantId, 10), quantity: 1, properties: engFeeProps });

          // Second side fee
          if (charm.engraving.secondSideVariantId && charm.engraving.side2Lines && charm.engraving.side2Lines.some(function (l) { return l; })) {
            var side2Props = {
              'For Charm': charm.title,
              'Bracelet': braceletTitle,
              'Slot': slotLabel + ' of ' + totalSlots,
              'Build': buildCode,
              'Side': '2',
              '_bracelet_variant': String(holderVid),
              '_builder_session': sessionId
            };
            charm.engraving.side2Lines.forEach(function (line, idx) {
              if (line) side2Props['Engraving Line ' + (idx + 1)] = line;
            });
            if (charm.engraving.fontLabel) side2Props['Font'] = charm.engraving.fontLabel;
            items.push({ id: parseInt(charm.engraving.secondSideVariantId, 10), quantity: 1, properties: side2Props });
          }
        }
      });

      if (doneBtn) doneBtn.disabled = true;
      var spinner = doneBtn && doneBtn.querySelector('.loading--spinner');
      if (doneText) doneText.classList.add('hidden');
      if (spinner) spinner.classList.remove('hidden');

      console.log('[CharmBuilder] addToCart items:', JSON.stringify(items.map(function(i){ return {id: i.id, qty: i.quantity}; })));

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || 'Could not add to cart');
            return data;
          });
        })
        .then(function (cartData) {
          // Clear persisted state — build is complete
          clearBuilderState();
          state.attachedCharms = {};
          state.activeHotspotId = null;
          renderHotspots();
          updateDoneButton();

          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.openCartDrawer === 'function') {
            // Pass a mock event — openCartDrawer expects an event object with
            // preventDefault() and target; calling it bare throws on event.preventDefault()
            cartDrawer.openCartDrawer({ preventDefault: function () {}, target: doneBtn });
          } else {
            window.location.href = '/cart';
          }
          if (cartData && cartData.items) {
            var qty = cartData.items.reduce(function (s, i) { return s + i.quantity; }, 0);
            document.querySelectorAll('[data-item-count], .cart-count-bubble').forEach(function (el) {
              el.classList.remove('hidden');
              el.textContent = qty < 100 ? qty : '99+';
            });
          }
        })
        .catch(function (err) { alert(err.message || 'Unable to add to cart.'); })
        .finally(function () {
          if (doneBtn) doneBtn.disabled = false;
          if (doneText) doneText.classList.remove('hidden');
          if (spinner) spinner.classList.add('hidden');
          updateDoneButton();
        });
    }

    // ── BACKDROP / ESC ─────────────────────────────────────────────────────
    if (backdrop) {
      backdrop.addEventListener('click', function () {
        if (engravePanel && !engravePanel.hidden) { closeEngravePanel(); return; }
        if (charmDetail && !charmDetail.hidden) { closeCharmDetail(); return; }
        if (holderOverlay && !holderOverlay.hidden) { closeHolderOverlay(); return; }
        closeContextMenu();
        closeSortDropdown();
        if (filterPanel) { filterPanel.hidden = true; if (filterBtn) filterBtn.setAttribute('aria-expanded', 'false'); }
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (engravePanel && !engravePanel.hidden) { closeEngravePanel(); return; }
      if (charmDetail && !charmDetail.hidden) { closeCharmDetail(); return; }
      if (holderOverlay && !holderOverlay.hidden) { closeHolderOverlay(); return; }
      if (contextMenu && !contextMenu.hidden) { closeContextMenu(); }
    });
    document.addEventListener('click', function (e) {
      if (sortDropdown && !sortDropdown.hidden && sortBtn && !sortBtn.contains(e.target) && !sortDropdown.contains(e.target)) {
        closeSortDropdown();
      }
      if (contextMenu && !contextMenu.hidden && !contextMenu.contains(e.target) && !(overlay && overlay.contains(e.target))) {
        closeContextMenu();
      }
    });
    // Close sort dropdown on scroll or resize so fixed positioning stays accurate
    window.addEventListener('scroll', closeSortDropdown, { passive: true });
    window.addEventListener('resize', closeSortDropdown, { passive: true });

    // ── AUTO-LOAD ALL CHARMS ───────────────────────────────────────────────
    // Fetches all charm products using the charm-builder-data collection view,
    // which reads actual metafields (engraving_enabled, jewelry-material).
    // Runs automatically on init — no manual Load More needed.
    var loadMoreBtn = $('#charm-builder-load-more');

    function buildCardFromMeta(p) {
      // p comes from our /collections/HANDLE?view=charm-builder-data endpoint.
      // Prices are in cents (Liquid variant.price). Engravable is a boolean. Material is a string.
      var variants = p.variants || [];
      var firstVariant = variants.find(function (v) { return v.available; }) || variants[0] || {};
      var isAvailable = variants.some(function (v) { return v.available; });
      var priceCents = p.variantPrice || firstVariant.price || 0;
      var featImg = p.featuredImage || '';
      var tags = p.tags || [];
      var tagsStr = tags.join('|');
      var material = p.material || '';
      var engravable = !!p.engravable;

      var variantsJson = JSON.stringify(variants);
      var imagesJson = JSON.stringify(p.images || []);

      var div = document.createElement('div');
      div.className = 'charm-builder-card charm-builder-card--charm' + (isAvailable ? '' : ' charm-builder-card--sold-out');
      div.setAttribute('role', isAvailable ? 'button' : 'img');
      div.setAttribute('tabindex', isAvailable ? '0' : '-1');
      div.setAttribute('aria-label', (p.title || '') + (isAvailable ? '' : ' (Sold out)'));
      div.setAttribute('data-available', isAvailable ? 'true' : 'false');
      div.setAttribute('data-product-id', p.id);
      div.setAttribute('data-product-handle', p.handle || '');
      div.setAttribute('data-product-title', p.title || '');
      div.setAttribute('data-material', p.materialHandlized || (material ? material.toLowerCase().replace(/\s+/g, '-') : ''));
      div.setAttribute('data-jewelry-material', material);
      div.setAttribute('data-engraving-enabled', engravable ? 'true' : 'false');
      div.setAttribute('data-engravable', engravable ? 'true' : 'false');
      div.setAttribute('data-max-engraving-lines', p.maxEngravingLines || 3);
      div.setAttribute('data-engraving-char-limit', p.engravingCharLimit || 12);
      div.setAttribute('data-featured-image', featImg);
      div.setAttribute('data-variant-id', p.variantId || firstVariant.id || '');
      div.setAttribute('data-variant-price', priceCents);
      div.setAttribute('data-tags', tagsStr);
      div.setAttribute('data-variants', variantsJson.replace(/"/g, '&quot;'));
      div.setAttribute('data-options', '[]');
      div.setAttribute('data-images', imagesJson.replace(/"/g, '&quot;'));
      if (p.engravingConfig) {
        div.setAttribute('data-engraving-config', JSON.stringify(p.engravingConfig).replace(/"/g, '&quot;'));
      }

      var imgHtml = featImg
        ? '<img src="' + esc(featImg) + '" alt="' + esc(p.title || '') + '" loading="lazy" width="200" height="200">'
        : '';
      var soldOutBadge = isAvailable ? '' : '<span class="charm-builder-card-sold-out-badge">Sold Out</span>';
      var variantNote = variants.length > 1
        ? '<span class="charm-builder-card-variants">' + variants.length + ' options</span>'
        : '';

      div.innerHTML =
        '<div class="charm-builder-card-media">' + imgHtml + soldOutBadge + '</div>' +
        '<div class="charm-builder-card-info">' +
          '<span class="charm-builder-card-title">' + esc(p.title || '') + '</span>' +
          '<span class="charm-builder-card-price">' + (isAvailable ? formatMoney(priceCents, config.moneyFormat) : 'Sold Out') + '</span>' +
          variantNote +
        '</div>';

      return div;
    }

    function appendProducts(products, existingIds) {
      var fragment = document.createDocumentFragment();
      products.forEach(function (p) {
        var sid = String(p.id);
        if (existingIds[sid]) return;
        // Skip products with no available variants — the builder's "Pick your
        // charms" picker is purchase-flow only, so a sold-out charm has no
        // useful state. Keeps the sold-out-card styling code as a fallback
        // for products that go out of stock between fetch and click.
        var hasAvailable = (p.variants || []).some(function (v) { return v.available; });
        if (!hasAvailable) return;
        existingIds[sid] = true;
        var card = buildCardFromMeta(p);
        fragment.appendChild(card);
        state.originalOrder.push(card);
      });
      if (charmGrid) charmGrid.appendChild(fragment);
    }

    function autoLoadAllCharms() {
      if (!charmGrid) return;
      var handle = config.charmCollectionHandle;
      var total  = config.charmProductsCount || 0;

      // Skip if no handle configured
      if (!handle) {
        console.warn('[CharmBuilder] No charm collection handle configured — set custom.charm_collection shop metafield');
        if (loadMoreBtn) loadMoreBtn.hidden = true;
        return;
      }

      // Skip AJAX if Liquid already pre-rendered ALL products (total 1-50, cards present).
      // buildFilters/applyFiltersAndSort/updateFilterBadge already ran in init before this call.
      var existingCardCount = charmGrid.querySelectorAll('.charm-builder-card--charm').length;
      if (total > 0 && total <= 50 && existingCardCount >= total) {
        if (loadMoreBtn) loadMoreBtn.hidden = true;
        return;
      }

      // Fast-path: if the parent collection has 0 products (total === 0 from products_count)
      // AND subcollections are configured, skip fetching the empty parent and go straight
      // to the first subcollection. This avoids an unnecessary round-trip.
      if (total === 0 && existingCardCount === 0 && Array.isArray(config.subcollections) && config.subcollections.length > 0) {
        var fastSub = config.subcollections[0];
        var fastBtn = subcolTabsWrap && subcolTabsWrap.querySelector('[data-subcol-handle="' + fastSub.handle + '"]');
        // Temporarily clear activeSubHandle so switchToCollection doesn't bail
        activeSubHandle = null;
        switchToCollection(fastSub.handle, fastBtn);
        return;
      }

      // Show loading state on the button (used as a progress indicator)
      if (loadMoreBtn) {
        loadMoreBtn.disabled = true;
        loadMoreBtn.classList.add('charm-builder-load-more-btn--loading');
        loadMoreBtn.textContent = 'Loading all charms\u2026';
      }

      // Build existing ID map from Liquid-rendered cards
      var existingIds = {};
      charmGrid.querySelectorAll('.charm-builder-card--charm').forEach(function (c) {
        existingIds[c.getAttribute('data-product-id')] = true;
      });

      // Fetch page 1 to discover total pages, then fetch remaining pages in parallel
      // Note: Shopify serves Liquid templates with text/html even when output is JSON,
      // so we skip the content-type check and let r.json() fail naturally if the
      // collection.charm-builder-data template is missing.
      fetch('/collections/' + handle + '?view=charm-builder-data')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          appendProducts(data.products || [], existingIds);
          var pages = data.pages || 1;
          if (pages <= 1) return Promise.resolve([]);
          var requests = [];
          for (var pg = 2; pg <= pages; pg++) {
            requests.push(
              fetch('/collections/' + handle + '?view=charm-builder-data&page=' + pg)
                .then(function (r) { return r.json(); })
            );
          }
          return Promise.all(requests);
        })
        .then(function (results) {
          if (results && results.length) {
            results.forEach(function (data) {
              appendProducts(data.products || [], existingIds);
            });
          }
          if (loadMoreBtn) loadMoreBtn.hidden = true;

          // If the "All" collection returned 0 products (parent collection with no direct
          // products — all charms live in subcollections), auto-switch to the first
          // subcollection so the grid isn't empty on load.
          var loadedCount = charmGrid.querySelectorAll('.charm-builder-card--charm').length;
          if (loadedCount === 0) {
            if (Array.isArray(config.subcollections) && config.subcollections.length > 0) {
              var firstSub = config.subcollections[0];
              var firstBtn = subcolTabsWrap && subcolTabsWrap.querySelector('[data-subcol-handle="' + firstSub.handle + '"]');
              activeSubHandle = null; // reset so switchToCollection doesn't bail
              switchToCollection(firstSub.handle, firstBtn);
              return;
            }
            console.warn('[CharmBuilder] No charms loaded. Ensure the charm collection has products, OR set custom.subcollections on the charm collection metafield to point to subcollections that contain charms.');
          }

          buildFilters();
          applyFiltersAndSort();
          updateFilterBadge();
        })
        .catch(function (err) {
          console.warn('[CharmBuilder] Charm auto-load error:', err);
          // Fall back to manual load more on error
          if (loadMoreBtn) {
            loadMoreBtn.disabled = false;
            loadMoreBtn.classList.remove('charm-builder-load-more-btn--loading');
            loadMoreBtn.textContent = 'Load More Charms';
            loadMoreBtn.addEventListener('click', function onClick() {
              loadMoreBtn.removeEventListener('click', onClick);
              autoLoadAllCharms();
            }, { once: true });
          }
        });
    }

    // ── SUBCOLLECTION TABS ────────────────────────────────────────────────
    // Reads config.subcollections and renders [All] + one tab per entry.
    // Clicking a tab swaps the charm grid contents via the same fetch path
    // used by autoLoadAllCharms().

    var activeSubHandle = config.charmCollectionHandle; // "All" by default

    function buildSubcollectionTabs() {
      var subs = Array.isArray(config.subcollections) ? config.subcollections : [];
      if (!subcolTabsWrap || subs.length === 0) return;

      var tabList = subcolTabsWrap.querySelector('.cb-subcol-tabs');
      if (!tabList) return;
      tabList.innerHTML = '';
      subcolTabsWrap.hidden = false;

      function makeTabCard(handle, title, imgSrc, isActive) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cb-subcol-tab' + (isActive ? ' cb-subcol-tab--active' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        btn.setAttribute('data-subcol-handle', handle);

        // Image / placeholder wrap
        var imgWrap = document.createElement('div');
        if (imgSrc) {
          imgWrap.className = 'cb-subcol-tab-img-wrap';
          var img = document.createElement('img');
          img.src = imgSrc;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 80;
          img.height = 80;
          imgWrap.appendChild(img);
        } else {
          // "All" placeholder: 3×3 grid icon
          imgWrap.className = 'cb-subcol-tab-img-wrap cb-subcol-tab-img-wrap--all';
          imgWrap.innerHTML = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>';
        }
        btn.appendChild(imgWrap);

        // Label
        var label = document.createElement('span');
        label.className = 'cb-subcol-tab-label';
        label.textContent = title;
        btn.appendChild(label);

        return btn;
      }

      // All tab
      var allBtn = makeTabCard(config.charmCollectionHandle, 'All', null, activeSubHandle === config.charmCollectionHandle);
      allBtn.addEventListener('click', function () { switchToCollection(config.charmCollectionHandle, allBtn); });
      tabList.appendChild(allBtn);

      // One card per subcollection
      subs.forEach(function (sub) {
        var btn = makeTabCard(sub.handle, sub.title, sub.image || null, activeSubHandle === sub.handle);
        btn.addEventListener('click', function () { switchToCollection(sub.handle, btn); });
        tabList.appendChild(btn);
      });
    }

    function switchToCollection(handle, clickedBtn) {
      if (handle === activeSubHandle) return; // already active
      activeSubHandle = handle;

      // Update tab active states
      if (subcolTabsWrap) {
        subcolTabsWrap.querySelectorAll('.cb-subcol-tab').forEach(function (b) {
          var isActive = b === clickedBtn;
          b.classList.toggle('cb-subcol-tab--active', isActive);
          b.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      // Clear current grid and state
      if (charmGrid) {
        charmGrid.innerHTML = '';
        // Inject skeleton cards so the grid doesn't flash empty
        for (var sk = 0; sk < 10; sk++) {
          var skel = document.createElement('div');
          skel.className = 'charm-builder-card charm-builder-card--skeleton';
          charmGrid.appendChild(skel);
        }
      }
      state.originalOrder = [];
      state.filters = { material: [], engravable: false, groups: {} };
      state.searchQuery = '';
      if (searchInput) searchInput.value = '';
      if (productCount) productCount.textContent = '';
      // Reset sort to featured
      state.sortMode = 'featured';
      if (sortDropdown) {
        sortDropdown.querySelectorAll('.charm-builder-sort-option').forEach(function (b) {
          var isFeatured = b.getAttribute('data-sort') === 'featured';
          b.classList.toggle('selected', isFeatured);
          b.setAttribute('aria-selected', isFeatured ? 'true' : 'false');
        });
      }
      // Reset favorites filter so it doesn't carry over to the new collection
      state.showFavoritesOnly = false;
      if (favsBtn) {
        favsBtn.setAttribute('aria-pressed', 'false');
        favsBtn.classList.remove('active');
      }

      // Immediately clear the filter panel UI + active chips so nothing stale
      // shows while the new collection is loading.
      buildFilters();
      updateFilterBadge();

      // Show loading indicator
      if (loadMoreBtn) {
        loadMoreBtn.hidden = false;
        loadMoreBtn.disabled = true;
        loadMoreBtn.classList.add('charm-builder-load-more-btn--loading');
        loadMoreBtn.textContent = 'Loading\u2026';
      }

      // Fetch all pages for the selected collection
      var existingIds = {};
      var subcollectionProductsAdded = 0;
      fetch('/collections/' + handle + '?view=charm-builder-data')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          // Remove skeleton placeholders as soon as the first real products arrive
          if (charmGrid) {
            charmGrid.querySelectorAll('.charm-builder-card--skeleton').forEach(function (el) { el.remove(); });
          }
          var batch = data.products || [];
          subcollectionProductsAdded += batch.length;
          appendProducts(batch, existingIds);
          var pages = data.pages || 1;
          if (pages <= 1) return Promise.resolve([]);
          var requests = [];
          for (var pg = 2; pg <= pages; pg++) {
            requests.push(
              fetch('/collections/' + handle + '?view=charm-builder-data&page=' + pg)
                .then(function (r) { return r.json(); })
            );
          }
          return Promise.all(requests);
        })
        .then(function (results) {
          if (results && results.length) {
            results.forEach(function (data) {
              var batch = data.products || [];
              subcollectionProductsAdded += batch.length;
              appendProducts(batch, existingIds);
            });
          }
          // Remove any remaining skeleton cards now that real content is in
          if (charmGrid) {
            charmGrid.querySelectorAll('.charm-builder-card--skeleton').forEach(function (el) { el.remove(); });
          }
          if (loadMoreBtn) loadMoreBtn.hidden = true;
          state.originalOrder = Array.from(charmGrid.querySelectorAll('.charm-builder-card--charm'));
          buildFilters();
          applyFiltersAndSort();
          updateFilterBadge();

          // If this subcollection has no buildable products, permanently hide the tab
          // and bounce back to All so the user isn't stranded on an empty view.
          if (subcollectionProductsAdded === 0 && clickedBtn) {
            clickedBtn.hidden = true;
            var allTab = subcolTabsWrap && subcolTabsWrap.querySelector(
              '[data-subcol-handle="' + config.charmCollectionHandle + '"]'
            );
            if (allTab) allTab.click();
          }
        })
        .catch(function (err) {
          console.warn('Subcollection load error:', err);
          if (charmGrid) {
            charmGrid.querySelectorAll('.charm-builder-card--skeleton').forEach(function (el) { el.remove(); });
          }
          if (loadMoreBtn) {
            loadMoreBtn.disabled = false;
            loadMoreBtn.classList.remove('charm-builder-load-more-btn--loading');
            loadMoreBtn.textContent = 'Retry';
          }
        });
    }

    // ── INIT ───────────────────────────────────────────────────────────────
    buildSubcollectionTabs();
    buildFilters();
    applyFiltersAndSort();
    updateDoneButton();
    autoLoadAllCharms();

    // ── RESTORE PERSISTED STATE ─────────────────────────────────────────────
    // In product mode the holder is always the current product, so we restore
    // charms only. In page mode we restore both holder and charms.
    (function restorePersistedState() {
      var saved = loadBuilderState();
      if (!saved || !saved.holderData) return;

      if (config.mode === 'product' && config.preselectedHolder) {
        // Holder is fixed — just restore charms
        state.attachedCharms = saved.attachedCharms || {};
        applyHolder(config.preselectedHolder);
      } else if (config.mode === 'page') {
        // URL param takes priority over saved state for the holder
        var params = new URLSearchParams(window.location.search);
        var holderHandle = params.get('holder');
        if (holderHandle) {
          // URL param wins on holder; restore charms, then URL-param select runs below
          state.attachedCharms = saved.attachedCharms || {};
        } else {
          // Restore both holder and charms
          state.attachedCharms = saved.attachedCharms || {};
          applyHolder(saved.holderData);
        }
      }
    })();

    if (config.mode === 'page' && !state.selectedHolder) {
      if (step1) step1.hidden = false;
      if (mainBody) mainBody.classList.add('charm-builder-body--hidden');
    }
  }

  // ── BOOT ────────────────────────────────────────────────────────────────
  function init() {
    var root = document.querySelector('.charm-builder');
    if (root) initSection(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
